export default __webpack_public_path__ + "static/media/almuerzo.3e026e3f.png";